import { Table } from 'antd'
import { ColumnsType } from 'antd/es/table'
import cronstrue from 'cronstrue'
import dayjs from 'dayjs'

import { GetTreatmentPlanPrescribedTreatmentResponse } from 'src/api/requests'
import { Text } from 'src/components'
import { dayMonthYearBackSlash } from 'src/libs'
import { useLocales } from 'src/locales'

import 'cronstrue/locales/ro'
import 'cronstrue/locales/ru'

type Props = {
  prescribedTreatments?: GetTreatmentPlanPrescribedTreatmentResponse[]
}

export const TreatmentConsumablesCard = ({ prescribedTreatments }: Props) => {
  const { t, currentLang } = useLocales()

  const columns: ColumnsType<GetTreatmentPlanPrescribedTreatmentResponse> = [
    {
      key: 'name',
      title: t('consultations.active_substance'),
      render: (_, { internationalName }) => {
        const name = internationalName?.name
        const prefixes = internationalName?.activeSubstances?.map(
          (substance) => substance?.prefix
        )

        const prefixLabel = (prefixes ?? [])
          .filter((p) => p?.trim() !== '')
          .join('+')

        const fullLabel = `${name} ${prefixLabel ? `(${prefixLabel})` : ''}`

        return <Text weight={700}>{fullLabel}</Text>
      }
    },
    {
      key: 'typeOfAdministration',
      align: 'center',
      title: t('treatments.medication_type'),
      render: (_, { productForm }) => productForm?.name ?? '-'
    },
    {
      key: 'amount',
      align: 'center',
      title: t('common.quantity'),
      dataIndex: 'amount'
    },
    {
      key: 'amountToAdminister',
      align: 'center',
      title: t('persons.treatment.treatment_prescribed'),
      render: (_, { amountToAdminister }) => amountToAdminister ?? '-'
    },
    {
      key: 'durationInDays',
      align: 'center',
      title: t('consultations.duration_days'),
      render: (_, { durationInDays }) => durationInDays ?? '-'
    },

    {
      key: 'cron',
      title: t('cron.schedule'),
      render: ({ scheduleExpression }) => (
        <Text>
          {scheduleExpression
            ? cronstrue.toString(scheduleExpression, {
                locale: currentLang?.value,
                verbose: true
              })
            : '-'}{' '}
        </Text>
      )
    },
    {
      key: 'startDate',
      title: t('cron.start_data_administration'),
      render: ({ startDate }) =>
        startDate ? dayjs(startDate).format(dayMonthYearBackSlash) : '-'
    },
    {
      key: 'endDate',
      title: t('cron.end_data_administration'),
      render: ({ endDate }) =>
        endDate ? dayjs(endDate).format(dayMonthYearBackSlash) : '-'
    }
  ]

  return (
    <>
      {!!prescribedTreatments?.length && (
        <Table
          columns={columns}
          scroll={{ x: 'max-content' }}
          dataSource={prescribedTreatments}
          pagination={false}
        />
      )}
    </>
  )
}
